import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';

/** `202`: the whole run, the source now transcribing. */
export type WorkflowRunSourceTranscriptionLaunchedAction = {
	type: 'WORKFLOW_RUN_SOURCE_TRANSCRIPTION_LAUNCHED';
	payload: WorkflowRunPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: WorkflowRunPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): WorkflowRunSourceTranscriptionLaunchedAction => ({
	type: 'WORKFLOW_RUN_SOURCE_TRANSCRIPTION_LAUNCHED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
